export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
